<template>
  <div class="space-x-2 select-none">
    <template v-if="!missingProject">
      <span v-if="projectName !== undefined" class="space-x-1 text-sm font-medium"
        ><slot name="project">{{ projectName }}</slot></span
      >
      <span v-if="financialOfficerName !== undefined" class="space-x-1 text-sm font-medium">
        <FontAwesomeIcon icon="coins" size="xs" title="Financieel verantwoordelijke" />
        <slot name="financialOfficer"
          ><span>{{ financialOfficerName }}</span></slot
        >
      </span>
      <span v-if="customerName" class="space-x-1 text-sm font-medium">
        <FontAwesomeIcon icon="building" size="xs" title="Bedrijf" />
        <slot name="customer"
          ><span>{{ customerName }}</span></slot
        >
      </span>
    </template>
    <span v-else class="text-sm font-medium">&lt;project invoeren&gt;</span>
  </div>
</template>
<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
defineProps<{
  projectName?: string
  financialOfficerName?: string
  customerName?: string
  missingProject?: boolean
}>()
</script>
